// Auto-hide toasts with progress bar
const TOAST_DURATION = 5000; // 5 seconds

export function initializeToasts() {
  const toasts = document.querySelectorAll<HTMLElement>('[data-toast]');

  toasts.forEach((toast) => {
    const progressBar = toast.querySelector<HTMLElement>('[data-toast-progress]');
    if (!progressBar) return;

    let remaining: number = TOAST_DURATION;
    let lastUpdateTime: number = Date.now();

    // Update progress bar
    const updateProgress = () => {
      if (toast.dataset.isPaused === 'true') return;

      const now = Date.now();
      const delta = now - lastUpdateTime;
      lastUpdateTime = now;

      remaining = Math.max(0, remaining - delta);
      const percentage = (remaining / TOAST_DURATION) * 100;

      progressBar.style.width = `${percentage}%`;

      if (remaining > 0) {
        requestAnimationFrame(updateProgress);
      } else {
        // Auto-hide after duration
        hideToast();
      }
    };

    const hideToast = () => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(400px)';
      toast.style.transition = 'opacity 300ms, transform 300ms';
      setTimeout(() => {
        toast.remove();
      }, 300);
    };

    // Mouse events
    toast.addEventListener('mouseenter', () => {
      toast.dataset.isPaused = 'true';
    });

    toast.addEventListener('mouseleave', () => {
      toast.dataset.isPaused = 'false';
      lastUpdateTime = Date.now();
      requestAnimationFrame(updateProgress);
    });

    // Start progress animation
    requestAnimationFrame(updateProgress);
  });
}
